import { render } from "./StepIndicator.vue?vue&type=template&id=c21c2d80&scoped=true"
import script from "./StepIndicator.vue?vue&type=script&lang=js"
export * from "./StepIndicator.vue?vue&type=script&lang=js"

import "./StepIndicator.vue?vue&type=style&index=0&id=c21c2d80&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c21c2d80"]])

export default __exports__